import { Spin } from 'antd';
import React, { Suspense, lazy } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const AdminsCreateContent = lazy(() => import('../../../components/Pages/Admins/Create'));

export default function AdminsCreate(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Admin Create`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <AdminsCreateContent />
      </Suspense>
    </Layout>
  );
}
